/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lush_Clear_Fish_FlipInputs */

const en_lush_clear_fish_flip = /** @type {(inputs: Lush_Clear_Fish_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removing memberships...`)
};

const de_lush_clear_fish_flip = /** @type {(inputs: Lush_Clear_Fish_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer entfernen...`)
};

/**
* | output |
* | --- |
* | "Removing memberships..." |
*
* @param {Lush_Clear_Fish_FlipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lush_clear_fish_flip = /** @type {((inputs?: Lush_Clear_Fish_FlipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lush_Clear_Fish_FlipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lush_clear_fish_flip(inputs)
	return de_lush_clear_fish_flip(inputs)
});